import { EncodeObject, GeneratedType } from '@cosmjs/proto-signing';
import { MsgCreateRollapp, MsgUpdateRollappInformation, MsgAddApp, MsgUpdateApp, MsgRemoveApp } from './ts-client/tx';

export const rollappTypes: ReadonlyArray<[ string, GeneratedType ]> = [
  [ '/dymensionxyz.dymension.rollapp.MsgCreateRollapp', MsgCreateRollapp ],
  [ '/dymensionxyz.dymension.rollapp.MsgUpdateRollappInformation', MsgUpdateRollappInformation ],
  [ '/dymensionxyz.dymension.rollapp.MsgAddApp', MsgAddApp ],
  [ '/dymensionxyz.dymension.rollapp.MsgUpdateApp', MsgUpdateApp ],
  [ '/dymensionxyz.dymension.rollapp.MsgRemoveApp', MsgRemoveApp ],
];

export interface MsgCreateRollappEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.rollapp.MsgCreateRollapp';
  readonly value: Partial<MsgCreateRollapp>;
}

export interface MsgUpdateRollappEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.rollapp.MsgUpdateRollappInformation';
  readonly value: Partial<MsgUpdateRollappInformation>;
}

export interface MsgAddAppEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.rollapp.MsgAddApp';
  readonly value: Partial<MsgAddApp>;
}

export interface MsgUpdateAppEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.rollapp.MsgUpdateApp';
  readonly value: Partial<MsgUpdateApp>;
}

export interface MsgRemoveAppEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.rollapp.MsgRemoveApp';
  readonly value: Partial<MsgRemoveApp>;
}

export function isMsgCreateRollappEncodeObject(object: EncodeObject): object is MsgCreateRollappEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.rollapp.MsgCreateRollapp';
}

export function isMsgUpdateRollappEncodeObject(object: EncodeObject): object is MsgUpdateRollappEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.rollapp.MsgUpdateRollappInformation';
}

export function isMsgAddAppEncodeObject(object: EncodeObject): object is MsgAddAppEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.rollapp.MsgAddApp';
}

export function isMsgUpdateAppEncodeObject(object: EncodeObject): object is MsgUpdateAppEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.rollapp.MsgUpdateApp';
}

export function isMsgRemoveAppEncodeObject(object: EncodeObject): object is MsgRemoveAppEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.rollapp.MsgRemoveApp';
}



